import settings from '@/settings'

let inserir = (data, headers) => {
  return fetch(`${settings.apetrusApi}/bandeiras/cadastrar/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let listBandeiras = (pagination, headers) => {
  return fetch(`${settings.apetrusApi}/bandeiras/?page=${pagination.page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  inserir,
  listBandeiras
}
